module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    staticClass: "SOM",
    attrs: {
      "epub:type": "toc"
    }
  }, [_c('h1', {
    staticClass: "SOM_titre",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("Contents")]), _vm._v(" "), _c('div', {
    staticClass: "SOM_pre"
  }, [_c('a', {
    attrs: {
      "href": "#/pre2"
    }
  }, [_c('i', [_vm._v("Foreword by Ed Stetzer")])])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_pre"
  }, [_c('a', {
    attrs: {
      "href": "#/pre3"
    }
  }, [_c('b', [_vm._v("1")]), _vm._v(" Introduction: The Challenge Congregations Face in America")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_part"
  }, [_c('a', {
    attrs: {
      "href": "#/p1"
    }
  }, [_c('span', {
    staticClass: "mev1"
  }, [_vm._v("Part 1")]), _vm._v(" Recovering a Missional Imagination for the Unchurched in America")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('a', {
    attrs: {
      "href": "#/p1chap1"
    }
  }, [_c('b', [_vm._v("2")]), _vm._v(" Exposing Common Myths About Unchurched Americans")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap2",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("3")]), _vm._v(" Embracing a New Narrative About the Unchurched")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap3",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("4")]), _vm._v(" Engaging the Receptive Millennials, Nones, and Nominals in Your Life")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap4",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("5")]), _vm._v(" Exploring the Conversion Community Equation")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_part"
  }, [_c('span', {
    attrs: {
      "href": "#/p2",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "mev1"
  }, [_vm._v("Part 2")]), _vm._v(" Developing Missional Leaders")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/p2chap1",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("6")]), _vm._v(" Modeling Outreach Others Can Imitate")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/p2chap2",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("7")]), _vm._v(" Multiplying Missional Leaders")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_part"
  }, [_c('span', {
    attrs: {
      "href": "#/p3",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "mev1"
  }, [_vm._v("Part 3")]), _vm._v(" Cultivating a Missional Congregation")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/p3chap1",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("8")]), _vm._v(" Belonging to the Broader Community")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/p3chap2",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("9")]), _vm._v(" Blessing the World to Reach the World")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/p3chap3",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("10")]), _vm._v(" Bringing the Community to Church")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/p3chap4",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("11")]), _vm._v(" Building a Community of the Beloved Through Hospitality")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/p3chap5",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("12")]), _vm._v(" Conclusion: From a Conversion Community to a Conversion Movement")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_appen_autre"
  }, [_c('span', {
    attrs: {
      "href": "#/appen4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Acknowledgments")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_appen"
  }, [_c('span', {
    attrs: {
      "href": "#/appen5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Billy Graham Center Resources")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_appen"
  }, [_c('span', {
    attrs: {
      "href": "#/appen6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Contributing Research Projects")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_appen"
  }, [_c('span', {
    attrs: {
      "href": "#/appen7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Notes")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_appen"
  }, [_c('span', {
    attrs: {
      "href": "#/appen8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Praise for "), _c('i', [_vm._v("You Found Me")])])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_appen"
  }, [_c('span', {
    attrs: {
      "href": "#/appen9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("About the Author")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_pdf"
  }, [_c('span', {
    attrs: {
      "href": "#/fin_acheve",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("More Titles from InterVarsity Press")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-029e4e6e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/sommaire.vue
// module id = 63
// module chunks = 0